import DetailTitle from "@/components/DetailTitle";
import qqImg from "@/assets/images/community/qq.png";
import styles from './index.module.scss'
import { Tooltip } from "antd";
import intl from "react-intl-universal";
const Chat = () => {
	return <div className={styles.chatBox}>
		<DetailTitle title="Chat" />
		{/* <Tooltip title={intl.get("community.Click here to join the Gitter English group")}>
			<a href="https://gitter.im/" target="_blank">https://gitter.im/</a>
		</Tooltip> */}
		{/* <br /> */}
		<img src={qqImg} />
		<div className={styles.desBox}>{intl.get("community.Scan to Join the QQ Group (Chinese)")}</div>
	</div>
}
export default Chat;